
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"65","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2232_4175)"}},[_c('circle',{attrs:{"cx":"32","cy":"32.715","r":"32","fill":"#1E1E1E"}}),_c('g',{attrs:{"clip-path":"url(#clip1_2232_4175)"}},[_c('path',{attrs:{"d":"M44.543 20.349l-11.44-9.356a1.254 1.254 0 00-1.575 0l-11.44 9.356a1.304 1.304 0 00-.463.972v32.143c0 .695.556 1.25 1.25 1.25H43.71c.695 0 1.25-.555 1.25-1.25V21.321c.047-.37-.138-.74-.416-.972zm-12.227-2.316a2.372 2.372 0 012.361 2.362 2.372 2.372 0 01-2.361 2.362 2.372 2.372 0 01-2.363-2.362 2.372 2.372 0 012.363-2.362zm1.25 27.928v1.76c0 .695-.556 1.25-1.25 1.25-.695 0-1.251-.555-1.251-1.25v-1.76c-1.621-.046-3.103-.926-3.844-2.362a1.281 1.281 0 01-.14-.602c0-.695.556-1.297 1.251-1.297.556 0 .973.324 1.158.787.37.556.973.926 1.668.926h2.27c1.11 0 1.99-.88 1.99-1.945 0-1.111-.88-1.991-1.99-1.991h-2.27a4.497 4.497 0 01-4.493-4.493 4.478 4.478 0 014.4-4.492v-1.714c0-.695.556-1.25 1.25-1.25.695 0 1.251.555 1.251 1.25v1.76c1.667.046 3.15.926 3.89 2.409a1.26 1.26 0 01-.555 1.713 1.26 1.26 0 01-1.714-.555c-.324-.649-.972-1.02-1.76-1.02h-2.27c-1.111 0-1.99.88-1.99 1.992s.88 1.991 1.99 1.991h2.27c2.501 0 4.493 2.038 4.493 4.493.046 2.362-1.9 4.354-4.354 4.4z","fill":"#74DBB5"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2232_4175"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .715)","d":"M0 0h64v64H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_2232_4175"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10.715)","d":"M0 0h44v44H0z"}})])])])
          )
        }
      }
    